import { ref, onUnmounted, watch } from 'vue';

export function useInfiniteScroll(options = {}) {
  const { rootMargin = '100px' } = options;

  const triggerRef = ref(null);
  let observer = null;
  let currentCallback = null;

  const stopObserving = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const createObserver = (callback) => {
    stopObserving();

    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && callback) {
          callback();
        }
      },
      { rootMargin }
    );

    if (triggerRef.value) {
      observer.observe(triggerRef.value);
    }
  };

  // Watch for triggerRef changes to automatically re-observe
  watch(triggerRef, (newElement) => {
    if (newElement && currentCallback) {
      createObserver(currentCallback);
    } else if (!newElement) {
      stopObserving();
    }
  });

  const startObserving = (callback) => {
    currentCallback = callback;
    createObserver(callback);
  };

  onUnmounted(() => {
    stopObserving();
  });

  return {
    triggerRef,
    startObserving,
    stopObserving,
  };
}
